var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 12.4286C7.75 10.9492 8.94924 9.75 10.4286 9.75C11.9079 9.75 13.1071 10.9492 13.1071 12.4286C13.1071 13.1684 12.8082 13.8371 12.3226 14.3226C11.8371 14.8082 11.1684 15.1071 10.4286 15.1071C8.94924 15.1071 7.75 13.9079 7.75 12.4286Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4C10.9155 4 12.9674 5.55718 13.7064 7.72247C14.3558 7.26719 15.1467 7 16 7C18.2091 7 20 8.79086 20 11C20 11.2443 19.9781 11.4836 19.9361 11.7158C21.1779 12.5168 22 13.9124 22 15.5C22 17.9853 19.9853 20 17.5 20H6.5C4.01472 20 2 17.9853 2 15.5C2 14.1098 2.63045 12.8668 3.62104 12.0413C3.22431 11.2812 3 10.4168 3 9.5C3 6.46243 5.46243 4 8.5 4ZM10.4286 8.25C8.12081 8.25 6.25 10.1208 6.25 12.4286C6.25 14.7363 8.12081 16.6071 10.4286 16.6071C11.3112 16.6071 12.1306 16.3329 12.8052 15.8658L14.4697 17.5303C14.7626 17.8232 15.2374 17.8232 15.5303 17.5303C15.8232 17.2374 15.8232 16.7626 15.5303 16.4697L13.8658 14.8052C14.3329 14.1306 14.6071 13.3112 14.6071 12.4286C14.6071 10.1208 12.7363 8.25 10.4286 8.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudSearch);
export default __webpack_public_path__ + "static/media/cloud-search.375a3581265f1a2ce02b78779be6f70d.svg";
export { ForwardRef as ReactComponent };